import React from 'react';

import { Container } from 'reactstrap';

//Import Breadcrumb
// import UserPanel from './UsersPanel';
import Users from './Users';
import Breadcrumbs from "../../components/Common/Breadcrumb";


const User = () => {
    document.title = "Onfon Group Legal Dept";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs title="Menu" breadcrumbItem="User Page" />
                    <div className="row">
                        {/* <UserPanel /> */}
                        <span width="100px"></span>
                        <Users />
                    </div>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default User;